import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  defaultLanguageSelector,
  emailSelector,
  firstNameSelector,
  languageSelector,
  lastNameSelector,
  phoneOrMobileSelector,
  translationsSelector,
  usernameSelector
} from '../../../selectors';
import { countryFromFullCode } from '../../../constants/browser';
import { SELECT_VALUES } from '../../post-box/UploadFileModal';

import { showChatBot } from './quriobot';
import { hideCurrentLiveAgentButton, showLiveAgentChat } from './liveAgentChat';
import { uploadFile } from '../../../actions';

const getUploadTypesForQurio = translations => {
  return SELECT_VALUES.map((v, index) => ({
    value: index + 1,
    label: translations[v.label] || v.label
  }));
};

const getUploadTypesForApi = translations => {
  return SELECT_VALUES.map((v, index) => ({
    value: v.value,
    label: translations[v.label] || v.label
  }));
};

const ChatComponent = ({ isAuthenticated, chatShow, chatBotShow }) => {
  const dispatch = useDispatch();

  const defaultLanguageFull = useSelector(defaultLanguageSelector);
  const defaultLanguage = countryFromFullCode(defaultLanguageFull);
  const language = useSelector(languageSelector) || defaultLanguage;
  const firstName = useSelector(firstNameSelector);
  const lastName = useSelector(lastNameSelector);
  const email = useSelector(emailSelector);
  const caseId = useSelector(usernameSelector);

  const translations = useSelector(translationsSelector);
  const uploadTypesForQurio = getUploadTypesForQurio(translations);
  const uploadTypesForApi = getUploadTypesForApi(translations);

  const customerEmail = useSelector(emailSelector);
  const customerPhone = useSelector(phoneOrMobileSelector);

  const uploadCallback = (files, type, method, value, description = '') => {
    dispatch(
      uploadFile({
        files,
        type,
        method,
        value,
        remember: false,
        description
      })
    );
  };

  useEffect(() => {
    if (chatBotShow) {
      showChatBot(
        isAuthenticated,
        true,
        language,
        firstName,
        lastName,
        email,
        caseId,
        uploadTypesForQurio,
        uploadTypesForApi,
        uploadCallback,
        customerEmail,
        customerPhone
      );
    } else if (chatShow) {
      showLiveAgentChat(
        true,
        isAuthenticated,
        language,
        email,
        firstName,
        lastName,
        caseId
      );
    } else {
      showChatBot(isAuthenticated, false);
      hideCurrentLiveAgentButton();
    }
  }, [chatBotShow, chatShow, language, firstName, lastName, email, caseId]);

  return null;
};

export default ChatComponent;
